<script>
export default {
  methods: {
    getTemporaryPassword () {
      const LENGTH = process.env.VUE_APP_PASSWORD_LENGTH // 生成したい文字列の長さ
      const SOURCE = []
      if (process.env.VUE_APP_PASSWORD_ALPHA_UPPER !== '') { SOURCE.push(process.env.VUE_APP_PASSWORD_ALPHA_UPPER) }
      if (process.env.VUE_APP_PASSWORD_ALPHA_LOWER !== '') { SOURCE.push(process.env.VUE_APP_PASSWORD_ALPHA_LOWER) }
      if (process.env.VUE_APP_PASSWORD_NUMERIC !== '') { SOURCE.push(process.env.VUE_APP_PASSWORD_NUMERIC) }
      if (process.env.VUE_APP_PASSWORD_SPECIAL !== '') { SOURCE.push(process.env.VUE_APP_PASSWORD_SPECIAL) }

      var OFFSET = SOURCE.length - 1
      var randomConfig = [] // ランダム設定配列
      var sum = 0
      var result = ''

      // どのSOURCEを何文字含むかをランダムで設定
      for (let i = 0; i <= OFFSET; i++) {
        var includeNum = (i === OFFSET) ? LENGTH - sum : 1 + Math.floor(Math.random() * (LENGTH - OFFSET - sum - i + 2))
        if (includeNum < 1) { includeNum = 1 } // 必ず1回は発生させる
        randomConfig.push({
          src: SOURCE[i], // 元になるSOURCE
          includeNum: includeNum, // 含む回数
          count: 0 // 含まれた回数
        })
        sum += includeNum
      }

      // 指定した長さのランダムな文字列を生成
      for (let i = 0; i < LENGTH; i++) {
        var index = 1 + Math.floor(Math.random() * randomConfig.length - 1)
        var randomSource = randomConfig[index]

        // ランダムなSOURCEから文字を選んで結合
        result += randomSource.src[Math.floor(Math.random() * randomSource.src.length)]

        randomSource.count++

        // countとincludeNumが一致したらrandomConfig配列から削除
        if (randomSource.count === randomSource.includeNum) {
          randomConfig.splice(index, 1)
        }
      }

      return result
    },
    checkPassword (newPassword, confirmPassword) {
      var result = ''

      const LENGTH = process.env.VUE_APP_PASSWORD_LENGTH // 生成したい文字列の長さ
      // パスワード長エラーチェック
      if (newPassword.length < LENGTH) {
        // result = 'LENGTH_ERR'
        result = [{ id: 'CMN0054E', params: [LENGTH] }]
        return result
      }

      const SOURCE = []
      const checkSTRONG = []
      var allowChar = ''
      var checkNotAllow = ''
      if (process.env.VUE_APP_PASSWORD_ALPHA_UPPER !== '') {
        SOURCE.push(process.env.VUE_APP_PASSWORD_ALPHA_UPPER)
        allowChar = allowChar + (process.env.VUE_APP_PASSWORD_ALPHA_UPPER).trim()
        checkSTRONG.push({ type: 'ALPHA_UPPER', check: '' })
      }
      if (process.env.VUE_APP_PASSWORD_ALPHA_LOWER !== '') {
        SOURCE.push(process.env.VUE_APP_PASSWORD_ALPHA_LOWER)
        allowChar = allowChar + (process.env.VUE_APP_PASSWORD_ALPHA_LOWER).trim()
        checkSTRONG.push({ type: 'ALPHA_LOWER', check: '' })
      }
      if (process.env.VUE_APP_PASSWORD_NUMERIC !== '') {
        SOURCE.push(process.env.VUE_APP_PASSWORD_NUMERIC)
        allowChar = allowChar + (process.env.VUE_APP_PASSWORD_NUMERIC).trim()
        checkSTRONG.push({ type: 'NUMERIC', check: '' })
      }
      if (process.env.VUE_APP_PASSWORD_SPECIAL !== '') {
        SOURCE.push(process.env.VUE_APP_PASSWORD_SPECIAL)
        allowChar = allowChar + (process.env.VUE_APP_PASSWORD_SPECIAL).trim()
        checkSTRONG.push({ type: 'SPECIAL', check: '' })
      }

      // パスワード強度エラーチェック
      var OFFSET = SOURCE.length - 1
      var passwordArray = newPassword.split('')
      for (let i = 0; i <= passwordArray.length - 1; i++) {
        for (let j = 0; j <= OFFSET; j++) {
          if (SOURCE[j].indexOf(passwordArray[i]) !== -1) {
            checkSTRONG[j].check = 'OK'
          }
        }
        // 許可文字エラーチェック
        if (allowChar.indexOf(passwordArray[i]) === -1) {
          checkNotAllow = passwordArray[i]
        }
      }
      // 強度チェック結果
      for (let i = 0; i <= OFFSET; i++) {
        if (checkSTRONG[i].check !== 'OK') {
          // result = 'STRONG_ERR'
          result = [{ id: 'CMN0057E', params: [] }]
          return result
        }
      }
      // 許可文字以外チェック結果
      if (checkNotAllow !== '') {
        // result = 'NOT_ALLOW_ERR'
        result = [{ id: 'CMN0055E', params: [checkNotAllow] }]
        return result
      }

      // パスワード確認入力エラーチェック
      if (newPassword !== confirmPassword) {
        // result = 'CONFIRM_ERR'
        result = [{ id: 'CMN0056E', params: [] }]
        return result
      }

      return result
    }
  }
}
</script>
